import Vue from "vue";
import Validation from "@/models/Validation";

export default class ValidationApi {

    constructor(api) {
        this.api = api;
    }

    validate(certificateName, callback, error) {
        this.api.getRaw((axios) => {
            axios.get("certificates/validate/" + certificateName).then((response) => {
                callback(new Validation(response.data));
            }).catch((err) => {
                if (error) error(err)
                else Vue.$log.error("Error", error);
            });
        }, true);
    }

    validateFile(certificateName, file, callback, error) {
        const formData = new FormData();
        formData.append("certificateId", certificateName);
        formData.append("file", file);

        this.api.getRaw((axios) => {
            axios.post("certificates/validate-file", formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((response) => {
                callback(new Validation(response.data));
            }).catch((err) => {
                if (error) error(err)
                else Vue.$log.error("Error", error);
            });
        }, true);
    }
}
